class PodcastPreviewEpisodes {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector(".podcast-preview__episodes");
    this.prevBtn = root.querySelector(".podcast-preview__arrow--prev");
    this.nextBtn = root.querySelector(".podcast-preview__arrow--next");
    if (!this.track || !this.prevBtn || !this.nextBtn) return;

    this.items = Array.from(this.track.children);
    this.prefetched = new Set();

    this.initFadeIn();

    this.updateHandler = this.throttle(this.updateArrows.bind(this), 100);

    this.prevBtn.addEventListener("click", () => this.scrollByCard(-1));
    this.nextBtn.addEventListener("click", () => this.scrollByCard(1));
    this.prevBtn.addEventListener("mouseenter", () => this.prefetchDirection(-1));
    this.nextBtn.addEventListener("mouseenter", () => this.prefetchDirection(1));
    this.prevBtn.addEventListener("focus", () => this.prefetchDirection(-1));
    this.nextBtn.addEventListener("focus", () => this.prefetchDirection(1));
    this.track.addEventListener("scroll", this.updateHandler, { passive: true });
    window.addEventListener("resize", this.updateHandler, { passive: true });

    // this.setupDrag(); // disabled for now, revisit later
    this.updateArrows();
  }

  initFadeIn() {
    this.items.forEach((li) => {
      const img = li.querySelector("img");
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add("is-loaded");
        return;
      }
      img.addEventListener("load", () => img.classList.add("is-loaded"), { once: true });
    });
  }

  setupDrag() {
    let isDown = false;
    let hasDragged = false;
    let startX = 0;
    let startScrollLeft = 0;

    this.track.style.cursor = "grab";

    this.track.addEventListener("mousedown", (e) => {
      isDown = true;
      hasDragged = false;
      startX = e.clientX;
      startScrollLeft = this.track.scrollLeft;
      this.track.style.cursor = "grabbing";
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      const delta = e.clientX - startX;
      if (Math.abs(delta) > 5) hasDragged = true;
      this.track.scrollLeft = startScrollLeft - delta;
    });

    const stopDrag = () => {
      if (!isDown) return;
      isDown = false;
      this.track.style.cursor = "grab";
    };
    window.addEventListener("mouseup", stopDrag);
    this.track.addEventListener("mouseleave", stopDrag);

    // Prevent the card link from navigating right after a real drag
    this.track.addEventListener(
      "click",
      (e) => {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      },
      { capture: true },
    );
  }

  throttle(fn, wait) {
    let last = 0;
    let timeout = null;
    return (...args) => {
      const now = Date.now();
      const remaining = wait - (now - last);
      if (remaining <= 0) {
        clearTimeout(timeout);
        last = now;
        fn(...args);
      } else {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          last = Date.now();
          fn(...args);
        }, remaining);
      }
    };
  }

  getStep() {
    const card = this.track.querySelector(".podcast-preview__episode-link");
    if (!card) return this.track.clientWidth;
    const style = window.getComputedStyle(this.track);
    const gap = parseFloat(style.columnGap || style.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  scrollByCard(direction) {
    this.prefetchDirection(direction);
    this.track.scrollBy({ left: this.getStep() * direction, behavior: "smooth" });
  }

  prefetchImage(li) {
    if (!li || this.prefetched.has(li)) return;
    this.prefetched.add(li);
    const img = li.querySelector("img");
    if (!img || !img.src || (img.complete && img.naturalWidth > 0)) return;
    const preloadImg = new Image();
    preloadImg.src = img.src;
  }

  prefetchDirection(direction) {
    const step = this.getStep();
    if (!step) return;
    const currentIndex = Math.round(this.track.scrollLeft / step);
    const visibleCount = Math.max(1, Math.round(this.track.clientWidth / step));
    const edgeIndex = direction > 0 ? currentIndex + visibleCount : currentIndex - 1;

    for (let i = 0; i <= 1; i++) {
      this.prefetchImage(this.items[edgeIndex + i * direction]);
    }
  }

  updateArrows() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const scrollLeft = this.track.scrollLeft;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft >= maxScroll - 1;

    this.prevBtn.disabled = atStart;
    this.nextBtn.disabled = maxScroll <= 1 ? true : atEnd;
  }
}

const podcastPreviewRoot = document.querySelector(".wrg.podcast-preview");
if (podcastPreviewRoot) {
  new PodcastPreviewEpisodes(podcastPreviewRoot);
}
